import s from './styles.module.css'

const SectionColumn = ({ children }) => {
  return <div className={s.col}>{children}</div>
}

export default SectionColumn
